module.exports = __webpack_public_path__ + "static/media/own_blend.3c66bafd.jpg";